import React from 'react';
import './SegmentedCountdown.scss';

const getClass = days => (days <= 14 && days >= 7 ? 'item green-common' : 'item orange-common');

export const SegmentedCountdown = ({ days }) => {
  const COUNTDOWN = 14;
  const countdownItems = [];

  if (days >= 0 && days <= COUNTDOWN) {
    for (let i = 0; i < COUNTDOWN; i += 1) {
      countdownItems.push(<div key={i} className={i < days ? getClass(days) : 'item'} />);
    }
  }

  return <div className="segment">{days > COUNTDOWN ? <div className="progress-bar" /> : countdownItems}</div>;
};
